// Jedno źródło formatowania dat w całej aplikacji (pl-PL, dd.mm.rrrr).
// Zamiast lokalnych kopii formatDate w widokach — importuj stąd.

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

// Strefa aplikacji — musi zgadzać się z `config/app.php`.
const STREFA_APLIKACJI = 'Europe/Warsaw';

function toDate(value) {
    if (!value) return null;
    // Data bez czasu: parsuj lokalnie (bez przesunięcia UTC)
    const d = new Date(DATE_ONLY.test(value) ? `${value}T00:00:00` : value);
    return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDate(value) {
    const d = toDate(value);
    return d
        ? d.toLocaleDateString('pl-PL', { day: '2-digit', month: '2-digit', year: 'numeric' })
        : '—';
}

/**
 * Dzisiejsza data w strefie aplikacji, w formacie zapisu (`rrrr-mm-dd`).
 *
 * Do podpowiadania daty domyślnej w formularzach. `new Date().toISOString()`
 * NIE nadaje się do tego celu: oddaje UTC, a między północą a drugą w nocy
 * (latem; zimą do pierwszej) to jest już wczorajszy dzień. Formularz podpowiadał
 * wtedy datę o dobę wstecz, a przebieg CI — który chodzi w UTC — rozjeżdżał się
 * z serwerem liczącym w Europe/Warsaw.
 *
 * `en-CA` daje `rrrr-mm-dd` bez ręcznego sklejania kawałków.
 */
export function dzisiajWStrefieAplikacji() {
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: STREFA_APLIKACJI,
        year: 'numeric', month: '2-digit', day: '2-digit',
    }).format(new Date());
}

export function formatDateTime(value) {
    const d = toDate(value);
    return d
        ? d.toLocaleString('pl-PL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
        : '—';
}

/**
 * Etykieta oddziału w wybierakach: „Nazwa (KOD)”, a bez kodu sama nazwa.
 *
 * Kod kanoniczny (F##/W##/P##) prowadzi się ręcznie — synchronizacja
 * z APP.PIERROT go nie wypełnia — więc na produkcji większość oddziałów go
 * nie ma. Sklejanie szablonem drukowało tam dosłownie „(null)”.
 */
export function etykietaOddzialu(oddzial) {
    return oddzial.branch_code ? `${oddzial.name} (${oddzial.branch_code})` : oddzial.name;
}

/** Rozmiar pliku do pokazania obok nazwy: B / KB / MB, pusto dla zera. */
export function formatFileSize(bytes) {
    if (!bytes) return '';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1048576).toFixed(1)} MB`;
}
